import request from '@/utils/request'

// 新增留言建议
export function noPermissionAdd(data) {
  return request({
    url: '/system/proposal/noPermissionAdd',
    method: 'post',
    data: data
  })
}